<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M37.998 5.57959C36.0212 20.97 15.7757 19.894 10.1201 29.4619C13.5985 16.3404 32.868 18.2672 37.998 5.57959ZM8.22648 28.8447C5.89928 29.9207 1.84489 33.1155 0.0348958 36.8111C-0.273903 39.0215 1.51969 40.1811 3.32169 38.6795C4.86488 35.2427 8.05968 32.9239 9.84487 31.8391L8.22648 28.8447ZM40 1C35.0284 7.37318 31.9584 7.33959 21.1476 7.84038C14.8749 8.10718 6.56648 12.3448 6.56648 21.9963C6.56648 27.3935 9.83647 36.6695 20.03 36.6779C36.2296 36.6943 40 16.0152 40 1Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "CategoryDestinationNaturalPark"
};
</script>
